export enum DeviceLogType {
  Application = 'APPLICATION',
  System = 'SYSTEM',
}

export enum DeviceLogStatus {
  InProgress = 'IN_PROGRESS',
  Failed = 'FAILED',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
  StopInProgress = 'STOP_IN_PROGRESS',
}

export enum DeviceLogFileType {
  ApplicationAndSystem = 'APPLICATION_AND_SYSTEM',
  Modem = 'MODEM',
}

export interface DeviceLogFile {
  readonly fileName: string;
  readonly fileType?: DeviceLogFileType;
  readonly logFileId: string;
  readonly size: number;
}

export interface DeviceLog {
  readonly id: string;
  readonly title?: string;
  readonly description?: string;
  readonly startDate?: Date;
  readonly duration?: number;
  readonly types?: DeviceLogType[];
  readonly status?: DeviceLogStatus;
  readonly files?: DeviceLogFile[];
}

export interface DeviceLogsResponse {
  readonly data: DeviceLog[];
  readonly pagination: {
    readonly itemsPerPage?: number;
    readonly startIndex?: number;
    readonly totalResults?: number;
  };
}
